'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Key = require('common/domain/value/key');
const CommentAPI = require('communication/infra/api/comment');
const CommentFactory = require('communication/domain/factory/comment');
const CommentCollection = require('communication/domain/collection/comment');

class Repository {
    constructor(project) {
        _.extend(this, Backbone.Events);

        this._project = project;
        this._comments = new Backbone.Collection();
    }


    /**
     * @param key {Key}
     * @param limit
     * @param cursor
     * @param options
     * @returns {*}
     */
    fetchByKey(key, limit=10, cursor=null, options) {
        const defaultLimit = 10;
        let pagination;

        return CommentAPI.getNextByRelatedKey(this._project.id, key, limit || defaultLimit, cursor, options)
            .then(commentData => {
                const factory = new CommentFactory(this._project);
                const commentsJSON = commentData.results;
                pagination = commentData.pagination;

                return Promise.all(
                    _.map(commentsJSON, j => {
                        return factory.build(j);
                    })
                );
            })
            .then(comments => {
                comments = this.add(comments, {merge: true});
                // 基本、返信コメントは含めないようにする
                if(!options || !options.flat) {
                    comments = _.filter(comments, c => !c.getReplyTo());
                }

                return {
                    models: comments,
                    pagination: pagination
                };
            });
    }

    fetchByKeyAndCommentID(key, commentID, limit) {
        const cursor = null;
        const options = {
            commentID: commentID,
        };

        return this.fetchByKey(key, limit, cursor, options);
    }

    add(comments, options) {
        if (!_.isArray(comments)) {
            comments = [comments];
        }

        let addedComments = [];

        _.each(comments, comment => {
            const trigger = !this._comments.get(comment.id);
            comment = this._comments.add(comment, {merge: true});

            if (comment.getReplyTo() && this._comments.get(comment.getReplyTo())) {
                this._comments.get(comment.getReplyTo()).addReplyComment(comment);
            }

            if(trigger) {
                this.trigger('add', comment);

                if(options && options.addCount) {
                    this.trigger('add:count', comment);
                }
            }

            addedComments.push(comment);
        });

        return addedComments;
    }

    get(id) {
        return this._comments.get(id);
    }
}

const repositories = {};

const find = function(project) {
    let r = repositories[project.id];
    if(!r) {
        r = new Repository(project);
        repositories[project.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./communication/domain/repository/comment.js